import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from 'helpers/theme';
import { ErrorText, Heading, SecondaryText } from 'components/core/Typography';
import type { SectionName } from '../AutomatedCheckModal';
import Spacer from 'sharedComponents/core/Spacers/Spacer';
import UploadFiles, { FileUpload } from '../UploadFiles';
import Button from 'components/Button/Button';

const useStyles = createUseStyles((theme: Theme) => ({
  divider: {
    width: '100%',
    height: 1,
    background: '#a4a4a442',
    margin: '30px 0px'
  },
  buttons: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    justifyContent: 'flex-end'
  },
  bold: {
    color: 'black',
    fontWeight: 'bold'
  }
}));

type Props = {
  onNext: () => void;
  successPennyPrice: number;
  failPennyPrice: number;
};

function Info({ successPennyPrice, failPennyPrice, onNext }: Props) {
  const classes = useStyles();
  return (
    <>
      <Heading>Background check verification</Heading>
      <SecondaryText>
        <>
          Background check verifications cost:
          <br /> • <strong>£{(successPennyPrice / 100).toFixed(2)}</strong> for
          a successful check <br />•{' '}
          <strong>£{(failPennyPrice / 100).toFixed(2)}</strong> for a
          unsuccessful check. <br />
          <br />
          <strong className={classes.bold}>
            Before starting the check ensure:
          </strong>
          <br />• The delegates name on our system matches the name on the
          forms. <br />
          • All documents are in PDF, JPG or PNG format
          <br />
          • All required documents are signed by the appropriate person
          <br />
          <br />
          Most checks should be verified within 45 seconds. Where there are
          complications to the check, described below, this can take up to 1
          week. <br />
          <br />
          <strong className={classes.bold}>Reasons for a longer check:</strong>
          <br />• Birth certificate used <br />
          • Difficult to read documents.
          <br />
          • Unspent convictions
          <br />
          • ID document dates not matching
          <br />
          <br />
          You will not be charged if you cancel during uploading of files.
        </>
      </SecondaryText>

      <div className={classes.divider} />
      {/* <ErrorText style={{ textAlign: 'right' }}>{errorText}</ErrorText> */}
      <Spacer vertical spacing={1} />
      <div className={classes.buttons}>
        <Button
          archetype="flatPrimary"
          onClick={() => {
            onNext();
          }}
        >
          Next
        </Button>
      </div>
    </>
  );
}

export default Info;
